var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-flow-filter"
  }, [_c('b-button', {
    staticClass: "btn-filter",
    attrs: {
      "id": "popover-manual-1",
      "variant": "white"
    },
    on: {
      "click": _vm.toggleFilterOpen
    }
  }, [_c('img', {
    staticClass: "my-auto",
    attrs: {
      "src": require("@/assets/event/filter.svg")
    }
  }), _c('span', {
    staticClass: "my-auto filter-btn-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.filter.button')) + " ")])]), _c('b-popover', {
    attrs: {
      "target": "popover-manual-1",
      "triggers": "click blur",
      "placement": "bottom",
      "boundary": "viewport",
      "show": _vm.isFilterOpen
    },
    on: {
      "update:show": function ($event) {
        _vm.isFilterOpen = $event;
      }
    }
  }, [_c('div', {
    staticClass: "titles"
  }, [_c('b-row', {
    staticClass: "h-100"
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "title-icons"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/master-data/location.svg")
    }
  }), _c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.filter.form.locations')) + " ")])])]), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "title-icons"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/master-data/people.svg")
    }
  }), _c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.filter.form.responsibles')) + " ")])])]), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "title-icons"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/master-data/three-line.svg")
    }
  }), _c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.filter.form.topics')) + " ")])])])], 1)], 1), _c('div', {
    staticClass: "filter"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('multi-checkbox-filter', {
    attrs: {
      "id": "location",
      "options": _vm.locationOptions
    },
    model: {
      value: _vm.formData.locationFilters,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "locationFilters", $$v);
      },
      expression: "formData.locationFilters"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('multi-checkbox-filter', {
    attrs: {
      "id": "responsible",
      "options": _vm.responsibleOptions
    },
    model: {
      value: _vm.formData.responsibleFilters,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "responsibleFilters", $$v);
      },
      expression: "formData.responsibleFilters"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('multi-checkbox-filter', {
    attrs: {
      "id": "topic",
      "options": _vm.topicOptions
    },
    model: {
      value: _vm.formData.topicFilters,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "topicFilters", $$v);
      },
      expression: "formData.topicFilters"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('form-input', {
    staticClass: "mb-0",
    attrs: {
      "id": "event-flow-search",
      "label": _vm.$t('event-flow.filter.form.search'),
      "type": "text"
    },
    model: {
      value: _vm.formData.search,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "search", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.search"
    }
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    staticClass: "btn-delete w-100",
    attrs: {
      "variant": "white"
    },
    on: {
      "click": _vm.onResetFilters
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.filter.delete-button')) + " ")])], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.onFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.filter.submit-button')) + " ")])], 1)], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }